import { render, staticRenderFns } from "./PagesRecommendedWidget.vue?vue&type=template&id=e5aecb9e&"
import script from "./PagesRecommendedWidget.vue?vue&type=script&lang=js&"
export * from "./PagesRecommendedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports